import React from 'react';
import { Check, Gift } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, PRICE_LABEL, finalIncludedItems } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const noMore = ['No more hours searching for the next drill', 'No more disconnected training ideas', 'No more trying to explain every technical position without a visual reference', 'No more repeating the same exercises because planning time ran out', 'No more wondering which progression should come next', 'No more seeing a technical error without knowing which drill may address it', 'No more building every training session from an empty page'];
const ctaHighlights = ['6 Complete Visual Coaching Systems', '150 Ready-to-Coach Sessions', '5 Professional Bonus Guides', 'Immediate Digital Access', 'Complete Digital PDF Bundle'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-blue-950 relative overflow-hidden" data-id="element-75" data-mp="zx4s4qy2a32w">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-76" data-mp="2c4wo4ojgcche">
        <div className="text-center mb-16" data-id="element-77" data-mp="2c6hiad1utteq">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-78" data-mp="2h3hruxxwxeal">
            Next week you can keep planning every session from scratch...
            <br data-id="element-79" data-mp="2m57065tr3duz" />
            <span className="text-amber-500" data-id="element-80" data-mp="2r1nq95kig2ap">
              Or you can open a complete 6-in-1 Visual Coaching System and already know where to
              start.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-81" data-mp="302c4a09wm2nl">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-82" data-mp="34u3vmd0vwces">
                <span className="text-amber-500 mt-1" data-id="element-83" data-mp="39rdhxjsz87ye">▸</span>
                <span className="text-white/80" data-id="element-84" data-mp="3eri2bkx09mtw">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-2" data-id="element-85" data-mp="3istsbrjska2m">
            Olympic Weightlifting Coach Ready does not replace your knowledge as a coach.
          </p>
          <p className="text-xl text-white/80" data-id="element-86" data-mp="1jov5y7tt92ka">
            It gives you a visual system for using that knowledge with greater structure,
            consistency and efficiency.
          </p>
        </div>

        <div className="bg-white border-2 border-amber-500 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-87" data-mp="1shydjzhryl70">
          <h3 className="text-2xl font-serif font-bold text-blue-950 mb-6 text-center border-b border-amber-500/30 pb-6" data-id="element-88" data-mp="1none4jfal6p4">
            Everything included:
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-89" data-mp="1xeot8lpo3erw">
            {finalIncludedItems.map(item => <div key={item.label} className="flex items-start gap-3" data-id="element-90" data-mp="2bezm1uajf3fp">
                {item.kind === 'bonus' ? <Gift size={18} className="text-blue-700 shrink-0 mt-0.5" data-id="element-91" data-mp="27btfeljija8p" /> : <Check size={18} className="text-amber-500 shrink-0 mt-0.5" data-id="element-92" data-mp="h3kv5a5sixyd" />}
                <span className="text-sm text-slate-700" data-id="element-93" data-mp="d1zm5zwdn3tg">{item.label}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-94" data-mp="6xjs5c8bt06q">
            <p className="text-xl font-serif font-bold text-blue-950 mb-1" data-id="element-95" data-mp="6w9u2n1h3s03">
              🏋️ OLYMPIC WEIGHTLIFTING COACH READY
            </p>
            <p className="text-base font-semibold text-amber-600 mb-3" data-id="element-96" data-mp="3p9q2coy7cpij">
              The Complete 6-in-1 Visual Coaching System
            </p>
            <p className="text-sm text-slate-500 mb-8" data-id="element-97" data-mp="3fcbngtrxg8sc">
              150 ready-to-coach Olympic Weightlifting sessions designed to help coaches plan less,
              teach visually, correct technique with more structure and develop athletes from
              beginner to advanced.
            </p>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-98" data-mp="3bct1rvsa7tog">
              🟠 GET THE COMPLETE 6-IN-1 VISUAL OLYMPIC WEIGHTLIFTING COACHING SYSTEM NOW
            </Button>
            <p className="text-3xl font-bold text-blue-950 mb-4" data-id="element-99" data-mp="35nt7wiseeawq">{PRICE_LABEL}</p>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-500 mb-8" data-id="element-100" data-mp="30oq1ov0olyn6">
              {ctaHighlights.map(highlight => <span key={highlight} data-id="element-101" data-mp="2vnk7esrdi3bj">• {highlight}</span>)}
            </div>
            <p className="text-lg font-serif font-bold text-blue-950" data-id="element-102" data-mp="2rn8ktafg9sxf">
              Stop building every session from scratch.
            </p>
            <p className="text-lg font-serif font-bold text-blue-950 mb-4" data-id="element-103" data-mp="2hy8ltr0y6xj8">
              Open the system. See the technique. Choose the progression. Coach.
            </p>
            <p className="text-sm font-bold tracking-widest text-amber-600" data-id="element-104" data-mp="2cwt1k16lgv1w">
              SEE IT. COACH IT. CORRECT IT. PROGRESS IT.
            </p>
          </div>
        </div>
      </div>
    </section>;
}